import { render, staticRenderFns } from "./UserRestoreModal.vue?vue&type=template&id=983c9684&"
import script from "./UserRestoreModal.vue?vue&type=script&lang=js&"
export * from "./UserRestoreModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports